export default __webpack_public_path__ + "static/media/one.0ffd2355.jpg";